export const tenantHomePath = (tenantId: string): string => `/t/${tenantId}`;

export const SERVERS_PATH = "/servers";

const RELEASED: ReadonlySet<string> = new Set(["deprovisioning", "deleted"]);

export const released = (status: string): boolean => RELEASED.has(status);

interface Listed {
  readonly tenantId: string;
  readonly guildId: string | null;
  readonly status: string;
}

export const tenantEntryPath = (tenant: Pick<Listed, "tenantId" | "guildId">): string =>
  tenant.guildId === null ? `${SERVERS_PATH}/${tenant.tenantId}` : tenantHomePath(tenant.tenantId);

export const landingPath = (tenants: readonly Listed[], lastTenantId: string | null): string => {
  const last = tenants.find(
    (tenant) =>
      tenant.tenantId === lastTenantId && tenant.guildId !== null && !released(tenant.status),
  );
  if (last !== undefined) return tenantHomePath(last.tenantId);
  const [only, second] = tenants;
  return only === undefined || second !== undefined ? SERVERS_PATH : tenantEntryPath(only);
};
